import { render, staticRenderFns } from "./Toolbar2_people.vue?vue&type=template&id=52415fcc&scoped=true&"
import script from "./Toolbar2_people.vue?vue&type=script&lang=js&"
export * from "./Toolbar2_people.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar2_people.vue?vue&type=style&index=0&id=52415fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52415fcc",
  null
  
)

export default component.exports